module.exports = "<section id=\"story\"></section>";